import { lazy } from "react";
import {
  KEY_REPRODUCTION,
  TITLE_REPRODUCTION,
  PATH_REPRODUCTION,
  PATH_REPRODUCTION_LOT_INTRANT,
  KEY_REPRODUCTION_LOT_INTRANT,
  TITLE_REPRODUCTION_LOT_INTRANT,
  PATH_REPRODUCTION_SEMENCE,
  KEY_REPRODUCTION_SEMENCE,
  TITLE_REPRODUCTION_SEMENCE,
  PATH_REPRODUCTION_INSEMINATION,
  KEY_REPRODUCTION_INSEMINATION,
  TITLE_REPRODUCTION_INSEMINATION,
  PATH_REPRODUCTION_MISE_BAS,
  KEY_REPRODUCTION_MISE_BAS,
  TITLE_REPRODUCTION_MISE_BAS,
  PATH_REPRODUCTION_PRODUIT,
  KEY_REPRODUCTION_PRODUIT,
  TITLE_REPRODUCTION_PRODUIT,
} from "layouts/reproduction/constant/path";

import { buildRouteItem } from "router/routesUtils";

/* const CampagneIntervention = lazy(() =>
  import("layouts/reproduction/rubrique/campagneIntervention")
);
const Intervention = lazy(() => import("layouts/reproduction/rubrique/intervention"));
const LotIntervention = lazy(() => import("layouts/reproduction/rubrique/lot_intervention")); */
const LotIntrant = lazy(() => import("layouts/reproduction/rubrique/lot_intrant"));
const Semence = lazy(() => import("layouts/reproduction/rubrique/semence"));
const Insemination = lazy(() => import("layouts/reproduction/rubrique/insemination"));
const Misebas = lazy(() => import("layouts/reproduction/rubrique/misebas"));
const ProduitMisebas = lazy(() => import("layouts/reproduction/rubrique/produitMisebas"));
/* const DashboardInsemination = lazy(() =>
  import("layouts/dashboard/rubrique/DashboardInsemination")
); */

const REPRODUCTION_MENU_ITEMS = [
  {
    title: TITLE_REPRODUCTION_LOT_INTRANT,
    key: KEY_REPRODUCTION,
    path: PATH_REPRODUCTION,
    component: LotIntrant,
  },
  {
    title: TITLE_REPRODUCTION_LOT_INTRANT,
    key: KEY_REPRODUCTION_LOT_INTRANT,
    path: PATH_REPRODUCTION_LOT_INTRANT,
    component: LotIntrant,
  },
  {
    title: TITLE_REPRODUCTION_SEMENCE,
    key: KEY_REPRODUCTION_SEMENCE,
    path: PATH_REPRODUCTION_SEMENCE,
    component: Semence,
  },
  {
    title: TITLE_REPRODUCTION_INSEMINATION,
    key: KEY_REPRODUCTION_INSEMINATION,
    path: PATH_REPRODUCTION_INSEMINATION,
    component: Insemination,
  },
  {
    title: TITLE_REPRODUCTION_MISE_BAS,
    key: KEY_REPRODUCTION_MISE_BAS,
    path: PATH_REPRODUCTION_MISE_BAS,
    component: Misebas,
  },
  {
    title: TITLE_REPRODUCTION_PRODUIT,
    key: KEY_REPRODUCTION_PRODUIT,
    path: PATH_REPRODUCTION_PRODUIT,
    component: ProduitMisebas,
  },
];

const ROUTES_REPRODUCTION = [
  buildRouteItem(
    TITLE_REPRODUCTION,
    KEY_REPRODUCTION,
    PATH_REPRODUCTION,
    REPRODUCTION_MENU_ITEMS,
    "egg"
  ),
];
export default ROUTES_REPRODUCTION;
